import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "sites/construction/components/layout/Navbar";
import Footer from "sites/construction/components/layout/Footer";

export default function AppLayout() {
    return (
        <>
            <Navbar />
            <Outlet />
            <Footer />
        </>
    );
}
